import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Element from 'element-ui';
import Utils from '@/assets/js/utils';
import Config from '@/assets/js/config';
import Request from '@/assets/js/request';
import Player from '@/assets/js/player';

import './assets/js/vueExtension';

import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/theme/index.css';

import './utils/vue-extension';
// Icon svg
import './icons';

Vue.use(Element);

Vue.prototype.$utils = Utils;
Vue.prototype.$config = Config;
Vue.prototype.$request = Request;
Vue.prototype.$pageSizes = [10, 25, 50, 100];
Vue.prototype.$player = Player;

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
